/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Resync_BtnInputs */



/**
* | output |
* | --- |
* | "Resync" |
*
* @param {Profile_Resync_BtnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_resync_btn = /** @type {((inputs?: Profile_Resync_BtnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Resync_BtnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Resynchroniser")
	if (locale === "es") return /** @type {LocalizedString} */ ("Resincronizar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ressincronizar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Risincronizza")
	return /** @type {LocalizedString} */ ("Resync")
});